import Vue from 'vue'
import { UserManager, WebStorageStateStore, Log } from 'oidc-client'

class AuthService {
  constructor () {
    let _silentRedirectUri = process.env.SILENT_REDIRECT_URI
    let _authority = process.env.STS_DOMAIN
    let _redirectUri = process.env.REDIRECT_URI
    let _postLogoutRedirectUri = process.env.POST_LOGOUT_REDIRECT_URI

    if (process.env.NODE_ENV === 'production') {
      _silentRedirectUri = window.location.origin + '/#/silent-renew'
      _authority = window.location.origin + '/idp'
      _redirectUri = window.location.origin + '/#/callback'
      _postLogoutRedirectUri = window.location.origin + '/'
    }

    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: _authority,
      client_id: 'doqument.ro',
      redirect_uri: _redirectUri,
      automaticSilentRenew: true,
      silent_redirect_uri: _silentRedirectUri,
      response_type: 'code',
      scope: 'openid generic-api',
      post_logout_redirect_uri: _postLogoutRedirectUri,
      filterProtocolClaims: true,
      loadUserInfo: true
    }

    this.user = null
    this.id = this.uuidv4()
    this._inited = false
    this.userManager = new UserManager(settings)

    Log.logger = console

    let _onUserLoaded = this.onUserLoaded.bind(this)

    this.userManager.events.addUserLoaded(_onUserLoaded)
  }

  startup () {
    // let isCB = false
    // let mgr = this.userManager
    // if (matchesPath(config.popup_redirect_uri)) {
    //   mgr.signinPopupCallback()
    //   isCB = true
    // } else if (matchesPath(config.silent_redirect_uri)) {
    //   mgr.signinSilentCallback()
    //   isCB = true
    // } else if (matchesPath(config.popup_post_logout_redirect_uri)) {
    //   mgr.signoutPopupCallback()
    //   isCB = true
    // }
    // if (isCB) return Promise.resolve(0)

    if (this._inited) {
      return Promise.resolve(true)
    } else {
      // load user from storage
      return this.userManager
        .getUser()
        .then(test => {
          this._inited = true
          if (test && !test.expired) {
            this.user = test
          }
          return true
        })
        .catch(err => {
          Log.warn(`Auth startup err = ${err}`)
          return false
        })
    }
  }

  uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  onUserSessionChanged () {
    console.info('onUserSessionChanged')
  }

  onUserSignedOut () {
    console.info('onUserSessionChanged')
  }

  onUserLoaded (user) {
    console.info('onUserLoaded: ' + user.access_token)
    this.user = user
  }

  getUser () {
    return this.user
    // return this.userManager.getUser()
  }

  login () {
    return this.userManager.signinRedirect()
  }

  logout () {
    return this.userManager.signoutRedirect()
  }

  getAccessToken () {
    return this.user.access_token
    // return this.userManager.getUser().then((data) => {
    //   return data.access_token
    // })
  }
}

const auth = new AuthService()

Vue.prototype.$auth = auth

export default auth
export { auth }



// WEBPACK FOOTER //
// ./src/services/auth.service.js